
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as testnH_6bhumlghoyH1OAczusmJ_Z1lVDINPPxdp70hFEc4Meta } from "/app/app/pages/test.vue?macro=true";
import { default as adminz1Gw1Dq233K8tppNz8SkJPssg0iAW4m1moM_sX63EsQMeta } from "/app/app/pages/admin.vue?macro=true";
import { default as index4nVS2Dd4a5t9zrU2j8coCxsqtPYupm_GEv_2EzeGhJUMeta } from "/app/app/pages/index.vue?macro=true";
import { default as exportDrtLZFFFzMh6icvt0n_ix0Woqy8q_egQK1KpFMaxI2EMeta } from "/app/app/pages/export.vue?macro=true";
import { default as rescue96TDFen6hn47gOUv_EZe0ydoH9TH9_XjakdoEBbQ8F4Meta } from "/app/app/pages/rescue.vue?macro=true";
import { default as loading4EIe3lX96Aw8LrtMngc2gqwrScSYkzRikbAilRyximgMeta } from "/app/app/pages/loading.vue?macro=true";
import { default as supportoS_cDAq_Lr_wP5sy2_rTv1Tpss8AgYpNsmsCvevSvMYMeta } from "/app/app/pages/support.vue?macro=true";
import { default as changeloge45zL8vhsByUVQEl7MxR0ztKgH_AM_oq1Y1Afg_9xDQMeta } from "/app/app/pages/changelog.vue?macro=true";
import { default as refresh_45cacheEJKYzOLtCOGVXZSiRamkYRRKMyPk_s4fuaN9BdFbLl4Meta } from "/app/app/pages/refresh-cache.vue?macro=true";
import { default as communicationsY0Hh2qaOukP2fA49C78L03SagndMLwwGW3LJV9rD09cMeta } from "/app/app/pages/communications.vue?macro=true";
import { default as _91policy_93cOlG5PelEzOe5zZNG_H21QVFLd7aXStN9U138aikFjUMeta } from "/app/app/pages/legal/[policy].vue?macro=true";
import { default as kyczaXwcssJpCkNNa7IrGSNHnQi6MR6d7ffWpvqjwJEbqMMeta } from "/app/app/pages/user-portal/kyc.vue?macro=true";
import { default as vipuOyUooMIKiNPJeg9X69aMMDIwUOjttwwXoFk1UZG5AUMeta } from "/app/app/pages/user-portal/vip.vue?macro=true";
import { default as under_45maintenanceO2NKJ_bcwiHullFnM7Vvpyg2PaW8THtvL8JYd_6mF_kMeta } from "/app/app/pages/under-maintenance.vue?macro=true";
import { default as _91id_93685El4kMPNeHjZC0lLtaQb0RqTuDy7vMqle5Wgj4tmkMeta } from "/app/app/pages/(public)/user/[id].vue?macro=true";
import { default as influencer_45programo3tQpEXDFmU76fOYvAaaESfi_S7wec8hAkhZiOZzD04Meta } from "/app/app/pages/influencer-program.vue?macro=true";
import { default as offersvDKhJs35kVfOFa0akqP3MW_I4DTpXbfKZl0TXgoybKMMeta } from "/app/app/pages/user-portal/offers.vue?macro=true";
import { default as activityR7ojS8s4tYFuvkLH8v6gunyQMvUoJPFnA3bEH_J7q20Meta } from "/app/app/pages/user-portal/activity.vue?macro=true";
import { default as _91id_93MavIS5oqaCjqL99wvFtns782GsWalaEXQVBJOrlPN_UMeta } from "/app/app/pages/craft/[merchant]/[id].vue?macro=true";
import { default as _91id_93__B9jQRQDrevqWnGJfSFKgPAkgExmNF_TQKlOYo8Pt0Meta } from "/app/app/pages/store/[merchant]/[id].vue?macro=true";
import { default as dashboard32j7DXbBAq42_1enAis0SO_SmRCse1Q2La1pBgLTzOYMeta } from "/app/app/pages/user-portal/dashboard.vue?macro=true";
import { default as _91id_93qv62mhUmcqmu6f7P_5HxWb4AKo74fcTEoZnmdeYdtXoMeta } from "/app/app/pages/user-portal/mint/[id].vue?macro=true";
import { default as referralsbJwnbtuOgFK4kIC12ExAsRRUkiaquxJKWLBDoVA35u0Meta } from "/app/app/pages/user-portal/referrals.vue?macro=true";
import { default as indexlQHlN2Wd0F9L0saeG3FU6BB3V0v5Hfzws_GSJdPbdgQMeta } from "/app/app/pages/craft/[merchant]/index.vue?macro=true";
import { default as _91id_93JuqvUoZEPyZ5E_3sIFOHfekhKSAJStA3RWu6jx0hfkYMeta } from "/app/app/pages/market/[merchant]/[id].vue?macro=true";
import { default as indexH9K6jpGzfAeMoWlcVHfEn8QOL3gmOQCt_4yKtk2L790Meta } from "/app/app/pages/store/[merchant]/index.vue?macro=true";
import { default as indexUu1lbFxChpxEoxYFRIuzDcK0RKzw9Z3Ah_9OvwYgbGwMeta } from "/app/app/pages/market/[merchant]/index.vue?macro=true";
import { default as _91id_93iexxIBppWUYJ0D8_SPxDAcsrR39gajK5qiu5buQxxggMeta } from "/app/app/pages/(public)/collectible/[id].vue?macro=true";
import { default as index_hchSyqXk4XT30YcOfKRxU5xXpeBaYq2XQlMlJLq65MMeta } from "/app/app/pages/user-portal/account/index.vue?macro=true";
import { default as indexBXTMhFDtBAV2BwB_YXRtfP8fnt8IkX_roaCg7kj7nGkMeta } from "/app/app/pages/collection/[merchant]/index.vue?macro=true";
import { default as devices1t2fQzdIfVswB06E2A22m4mgMdNzTRz8O_5PsHY9NbsMeta } from "/app/app/pages/user-portal/account/devices.vue?macro=true";
import { default as _91id_93bzLfj4IfWMOZLCiZ_dysNTHBzIi7ZoIph3VRmnasRG0Meta } from "/app/app/pages/user-portal/collection/[id].vue?macro=true";
import { default as index8s9ry6q4Ho5Gq0447fhLJ66XxnYdpBbyxcl7z_GclhEMeta } from "/app/app/pages/user-portal/collection/index.vue?macro=true";
import { default as whats_45new_45builderCS83ka17_dbyY4tvwjzWtFaJQr1ffgaXeEfNBNhfWckMeta } from "/app/app/pages/user-portal/whats-new-builder.vue?macro=true";
import { default as _91setId_934WUMax3ZUGbMLM4vNK_gTAAslov_UTt9GFkiN50xSwYMeta } from "/app/app/pages/market/[merchant]/stack/[setId].vue?macro=true";
import { default as _91categoryId_93ORlQpgeUyaEA_nrY3kJMWajRtRxkGW33w6ao_lYRHfAMeta } from "/app/app/pages/craft/[merchant]/category/[categoryId].vue?macro=true";
import { default as _91categoryId_93v4OcbxC1b_WbXaCcjvecaiZ9RaW_8esaP1rtXzjbIq8Meta } from "/app/app/pages/store/[merchant]/category/[categoryId].vue?macro=true";
import { default as component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta } from "/app/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA } from "/app/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "test___en",
    path: "/test",
    component: () => import("/app/app/pages/test.vue")
  },
  {
    name: "test___es",
    path: "/es/test",
    component: () => import("/app/app/pages/test.vue")
  },
  {
    name: "test___pt",
    path: "/pt/test",
    component: () => import("/app/app/pages/test.vue")
  },
  {
    name: "test___ja",
    path: "/ja/test",
    component: () => import("/app/app/pages/test.vue")
  },
  {
    name: "test___ko",
    path: "/ko/test",
    component: () => import("/app/app/pages/test.vue")
  },
  {
    name: "test___de",
    path: "/de/test",
    component: () => import("/app/app/pages/test.vue")
  },
  {
    name: "test___it",
    path: "/it/test",
    component: () => import("/app/app/pages/test.vue")
  },
  {
    name: "test___fr",
    path: "/fr/test",
    component: () => import("/app/app/pages/test.vue")
  },
  {
    name: "test___zh",
    path: "/zh/test",
    component: () => import("/app/app/pages/test.vue")
  },
  {
    name: "admin___en",
    path: "/admin",
    component: () => import("/app/app/pages/admin.vue")
  },
  {
    name: "admin___es",
    path: "/es/admin",
    component: () => import("/app/app/pages/admin.vue")
  },
  {
    name: "admin___pt",
    path: "/pt/admin",
    component: () => import("/app/app/pages/admin.vue")
  },
  {
    name: "admin___ja",
    path: "/ja/admin",
    component: () => import("/app/app/pages/admin.vue")
  },
  {
    name: "admin___ko",
    path: "/ko/admin",
    component: () => import("/app/app/pages/admin.vue")
  },
  {
    name: "admin___de",
    path: "/de/admin",
    component: () => import("/app/app/pages/admin.vue")
  },
  {
    name: "admin___it",
    path: "/it/admin",
    component: () => import("/app/app/pages/admin.vue")
  },
  {
    name: "admin___fr",
    path: "/fr/admin",
    component: () => import("/app/app/pages/admin.vue")
  },
  {
    name: "admin___zh",
    path: "/zh/admin",
    component: () => import("/app/app/pages/admin.vue")
  },
  {
    name: "index___en",
    path: "/",
    component: () => import("/app/app/pages/index.vue")
  },
  {
    name: "index___es",
    path: "/es",
    component: () => import("/app/app/pages/index.vue")
  },
  {
    name: "index___pt",
    path: "/pt",
    component: () => import("/app/app/pages/index.vue")
  },
  {
    name: "index___ja",
    path: "/ja",
    component: () => import("/app/app/pages/index.vue")
  },
  {
    name: "index___ko",
    path: "/ko",
    component: () => import("/app/app/pages/index.vue")
  },
  {
    name: "index___de",
    path: "/de",
    component: () => import("/app/app/pages/index.vue")
  },
  {
    name: "index___it",
    path: "/it",
    component: () => import("/app/app/pages/index.vue")
  },
  {
    name: "index___fr",
    path: "/fr",
    component: () => import("/app/app/pages/index.vue")
  },
  {
    name: "index___zh",
    path: "/zh",
    component: () => import("/app/app/pages/index.vue")
  },
  {
    name: "export___en",
    path: "/export",
    meta: exportDrtLZFFFzMh6icvt0n_ix0Woqy8q_egQK1KpFMaxI2EMeta || {},
    component: () => import("/app/app/pages/export.vue")
  },
  {
    name: "export___es",
    path: "/es/export",
    meta: exportDrtLZFFFzMh6icvt0n_ix0Woqy8q_egQK1KpFMaxI2EMeta || {},
    component: () => import("/app/app/pages/export.vue")
  },
  {
    name: "export___pt",
    path: "/pt/export",
    meta: exportDrtLZFFFzMh6icvt0n_ix0Woqy8q_egQK1KpFMaxI2EMeta || {},
    component: () => import("/app/app/pages/export.vue")
  },
  {
    name: "export___ja",
    path: "/ja/export",
    meta: exportDrtLZFFFzMh6icvt0n_ix0Woqy8q_egQK1KpFMaxI2EMeta || {},
    component: () => import("/app/app/pages/export.vue")
  },
  {
    name: "export___ko",
    path: "/ko/export",
    meta: exportDrtLZFFFzMh6icvt0n_ix0Woqy8q_egQK1KpFMaxI2EMeta || {},
    component: () => import("/app/app/pages/export.vue")
  },
  {
    name: "export___de",
    path: "/de/export",
    meta: exportDrtLZFFFzMh6icvt0n_ix0Woqy8q_egQK1KpFMaxI2EMeta || {},
    component: () => import("/app/app/pages/export.vue")
  },
  {
    name: "export___it",
    path: "/it/export",
    meta: exportDrtLZFFFzMh6icvt0n_ix0Woqy8q_egQK1KpFMaxI2EMeta || {},
    component: () => import("/app/app/pages/export.vue")
  },
  {
    name: "export___fr",
    path: "/fr/export",
    meta: exportDrtLZFFFzMh6icvt0n_ix0Woqy8q_egQK1KpFMaxI2EMeta || {},
    component: () => import("/app/app/pages/export.vue")
  },
  {
    name: "export___zh",
    path: "/zh/export",
    meta: exportDrtLZFFFzMh6icvt0n_ix0Woqy8q_egQK1KpFMaxI2EMeta || {},
    component: () => import("/app/app/pages/export.vue")
  },
  {
    name: "rescue___en",
    path: "/rescue",
    component: () => import("/app/app/pages/rescue.vue")
  },
  {
    name: "rescue___es",
    path: "/es/rescue",
    component: () => import("/app/app/pages/rescue.vue")
  },
  {
    name: "rescue___pt",
    path: "/pt/rescue",
    component: () => import("/app/app/pages/rescue.vue")
  },
  {
    name: "rescue___ja",
    path: "/ja/rescue",
    component: () => import("/app/app/pages/rescue.vue")
  },
  {
    name: "rescue___ko",
    path: "/ko/rescue",
    component: () => import("/app/app/pages/rescue.vue")
  },
  {
    name: "rescue___de",
    path: "/de/rescue",
    component: () => import("/app/app/pages/rescue.vue")
  },
  {
    name: "rescue___it",
    path: "/it/rescue",
    component: () => import("/app/app/pages/rescue.vue")
  },
  {
    name: "rescue___fr",
    path: "/fr/rescue",
    component: () => import("/app/app/pages/rescue.vue")
  },
  {
    name: "rescue___zh",
    path: "/zh/rescue",
    component: () => import("/app/app/pages/rescue.vue")
  },
  {
    name: "loading___en",
    path: "/loading",
    component: () => import("/app/app/pages/loading.vue")
  },
  {
    name: "loading___es",
    path: "/es/loading",
    component: () => import("/app/app/pages/loading.vue")
  },
  {
    name: "loading___pt",
    path: "/pt/loading",
    component: () => import("/app/app/pages/loading.vue")
  },
  {
    name: "loading___ja",
    path: "/ja/loading",
    component: () => import("/app/app/pages/loading.vue")
  },
  {
    name: "loading___ko",
    path: "/ko/loading",
    component: () => import("/app/app/pages/loading.vue")
  },
  {
    name: "loading___de",
    path: "/de/loading",
    component: () => import("/app/app/pages/loading.vue")
  },
  {
    name: "loading___it",
    path: "/it/loading",
    component: () => import("/app/app/pages/loading.vue")
  },
  {
    name: "loading___fr",
    path: "/fr/loading",
    component: () => import("/app/app/pages/loading.vue")
  },
  {
    name: "loading___zh",
    path: "/zh/loading",
    component: () => import("/app/app/pages/loading.vue")
  },
  {
    name: "support___en",
    path: "/support",
    meta: supportoS_cDAq_Lr_wP5sy2_rTv1Tpss8AgYpNsmsCvevSvMYMeta || {},
    component: () => import("/app/app/pages/support.vue")
  },
  {
    name: "support___es",
    path: "/es/support",
    meta: supportoS_cDAq_Lr_wP5sy2_rTv1Tpss8AgYpNsmsCvevSvMYMeta || {},
    component: () => import("/app/app/pages/support.vue")
  },
  {
    name: "support___pt",
    path: "/pt/support",
    meta: supportoS_cDAq_Lr_wP5sy2_rTv1Tpss8AgYpNsmsCvevSvMYMeta || {},
    component: () => import("/app/app/pages/support.vue")
  },
  {
    name: "support___ja",
    path: "/ja/support",
    meta: supportoS_cDAq_Lr_wP5sy2_rTv1Tpss8AgYpNsmsCvevSvMYMeta || {},
    component: () => import("/app/app/pages/support.vue")
  },
  {
    name: "support___ko",
    path: "/ko/support",
    meta: supportoS_cDAq_Lr_wP5sy2_rTv1Tpss8AgYpNsmsCvevSvMYMeta || {},
    component: () => import("/app/app/pages/support.vue")
  },
  {
    name: "support___de",
    path: "/de/support",
    meta: supportoS_cDAq_Lr_wP5sy2_rTv1Tpss8AgYpNsmsCvevSvMYMeta || {},
    component: () => import("/app/app/pages/support.vue")
  },
  {
    name: "support___it",
    path: "/it/support",
    meta: supportoS_cDAq_Lr_wP5sy2_rTv1Tpss8AgYpNsmsCvevSvMYMeta || {},
    component: () => import("/app/app/pages/support.vue")
  },
  {
    name: "support___fr",
    path: "/fr/support",
    meta: supportoS_cDAq_Lr_wP5sy2_rTv1Tpss8AgYpNsmsCvevSvMYMeta || {},
    component: () => import("/app/app/pages/support.vue")
  },
  {
    name: "support___zh",
    path: "/zh/support",
    meta: supportoS_cDAq_Lr_wP5sy2_rTv1Tpss8AgYpNsmsCvevSvMYMeta || {},
    component: () => import("/app/app/pages/support.vue")
  },
  {
    name: "changelog___en",
    path: "/changelog",
    meta: changeloge45zL8vhsByUVQEl7MxR0ztKgH_AM_oq1Y1Afg_9xDQMeta || {},
    component: () => import("/app/app/pages/changelog.vue")
  },
  {
    name: "changelog___es",
    path: "/es/changelog",
    meta: changeloge45zL8vhsByUVQEl7MxR0ztKgH_AM_oq1Y1Afg_9xDQMeta || {},
    component: () => import("/app/app/pages/changelog.vue")
  },
  {
    name: "changelog___pt",
    path: "/pt/changelog",
    meta: changeloge45zL8vhsByUVQEl7MxR0ztKgH_AM_oq1Y1Afg_9xDQMeta || {},
    component: () => import("/app/app/pages/changelog.vue")
  },
  {
    name: "changelog___ja",
    path: "/ja/changelog",
    meta: changeloge45zL8vhsByUVQEl7MxR0ztKgH_AM_oq1Y1Afg_9xDQMeta || {},
    component: () => import("/app/app/pages/changelog.vue")
  },
  {
    name: "changelog___ko",
    path: "/ko/changelog",
    meta: changeloge45zL8vhsByUVQEl7MxR0ztKgH_AM_oq1Y1Afg_9xDQMeta || {},
    component: () => import("/app/app/pages/changelog.vue")
  },
  {
    name: "changelog___de",
    path: "/de/changelog",
    meta: changeloge45zL8vhsByUVQEl7MxR0ztKgH_AM_oq1Y1Afg_9xDQMeta || {},
    component: () => import("/app/app/pages/changelog.vue")
  },
  {
    name: "changelog___it",
    path: "/it/changelog",
    meta: changeloge45zL8vhsByUVQEl7MxR0ztKgH_AM_oq1Y1Afg_9xDQMeta || {},
    component: () => import("/app/app/pages/changelog.vue")
  },
  {
    name: "changelog___fr",
    path: "/fr/changelog",
    meta: changeloge45zL8vhsByUVQEl7MxR0ztKgH_AM_oq1Y1Afg_9xDQMeta || {},
    component: () => import("/app/app/pages/changelog.vue")
  },
  {
    name: "changelog___zh",
    path: "/zh/changelog",
    meta: changeloge45zL8vhsByUVQEl7MxR0ztKgH_AM_oq1Y1Afg_9xDQMeta || {},
    component: () => import("/app/app/pages/changelog.vue")
  },
  {
    name: "refresh-cache___en",
    path: "/refresh-cache",
    meta: refresh_45cacheEJKYzOLtCOGVXZSiRamkYRRKMyPk_s4fuaN9BdFbLl4Meta || {},
    component: () => import("/app/app/pages/refresh-cache.vue")
  },
  {
    name: "refresh-cache___es",
    path: "/es/refresh-cache",
    meta: refresh_45cacheEJKYzOLtCOGVXZSiRamkYRRKMyPk_s4fuaN9BdFbLl4Meta || {},
    component: () => import("/app/app/pages/refresh-cache.vue")
  },
  {
    name: "refresh-cache___pt",
    path: "/pt/refresh-cache",
    meta: refresh_45cacheEJKYzOLtCOGVXZSiRamkYRRKMyPk_s4fuaN9BdFbLl4Meta || {},
    component: () => import("/app/app/pages/refresh-cache.vue")
  },
  {
    name: "refresh-cache___ja",
    path: "/ja/refresh-cache",
    meta: refresh_45cacheEJKYzOLtCOGVXZSiRamkYRRKMyPk_s4fuaN9BdFbLl4Meta || {},
    component: () => import("/app/app/pages/refresh-cache.vue")
  },
  {
    name: "refresh-cache___ko",
    path: "/ko/refresh-cache",
    meta: refresh_45cacheEJKYzOLtCOGVXZSiRamkYRRKMyPk_s4fuaN9BdFbLl4Meta || {},
    component: () => import("/app/app/pages/refresh-cache.vue")
  },
  {
    name: "refresh-cache___de",
    path: "/de/refresh-cache",
    meta: refresh_45cacheEJKYzOLtCOGVXZSiRamkYRRKMyPk_s4fuaN9BdFbLl4Meta || {},
    component: () => import("/app/app/pages/refresh-cache.vue")
  },
  {
    name: "refresh-cache___it",
    path: "/it/refresh-cache",
    meta: refresh_45cacheEJKYzOLtCOGVXZSiRamkYRRKMyPk_s4fuaN9BdFbLl4Meta || {},
    component: () => import("/app/app/pages/refresh-cache.vue")
  },
  {
    name: "refresh-cache___fr",
    path: "/fr/refresh-cache",
    meta: refresh_45cacheEJKYzOLtCOGVXZSiRamkYRRKMyPk_s4fuaN9BdFbLl4Meta || {},
    component: () => import("/app/app/pages/refresh-cache.vue")
  },
  {
    name: "refresh-cache___zh",
    path: "/zh/refresh-cache",
    meta: refresh_45cacheEJKYzOLtCOGVXZSiRamkYRRKMyPk_s4fuaN9BdFbLl4Meta || {},
    component: () => import("/app/app/pages/refresh-cache.vue")
  },
  {
    name: "communications___en",
    path: "/communications",
    meta: communicationsY0Hh2qaOukP2fA49C78L03SagndMLwwGW3LJV9rD09cMeta || {},
    component: () => import("/app/app/pages/communications.vue")
  },
  {
    name: "communications___es",
    path: "/es/communications",
    meta: communicationsY0Hh2qaOukP2fA49C78L03SagndMLwwGW3LJV9rD09cMeta || {},
    component: () => import("/app/app/pages/communications.vue")
  },
  {
    name: "communications___pt",
    path: "/pt/communications",
    meta: communicationsY0Hh2qaOukP2fA49C78L03SagndMLwwGW3LJV9rD09cMeta || {},
    component: () => import("/app/app/pages/communications.vue")
  },
  {
    name: "communications___ja",
    path: "/ja/communications",
    meta: communicationsY0Hh2qaOukP2fA49C78L03SagndMLwwGW3LJV9rD09cMeta || {},
    component: () => import("/app/app/pages/communications.vue")
  },
  {
    name: "communications___ko",
    path: "/ko/communications",
    meta: communicationsY0Hh2qaOukP2fA49C78L03SagndMLwwGW3LJV9rD09cMeta || {},
    component: () => import("/app/app/pages/communications.vue")
  },
  {
    name: "communications___de",
    path: "/de/communications",
    meta: communicationsY0Hh2qaOukP2fA49C78L03SagndMLwwGW3LJV9rD09cMeta || {},
    component: () => import("/app/app/pages/communications.vue")
  },
  {
    name: "communications___it",
    path: "/it/communications",
    meta: communicationsY0Hh2qaOukP2fA49C78L03SagndMLwwGW3LJV9rD09cMeta || {},
    component: () => import("/app/app/pages/communications.vue")
  },
  {
    name: "communications___fr",
    path: "/fr/communications",
    meta: communicationsY0Hh2qaOukP2fA49C78L03SagndMLwwGW3LJV9rD09cMeta || {},
    component: () => import("/app/app/pages/communications.vue")
  },
  {
    name: "communications___zh",
    path: "/zh/communications",
    meta: communicationsY0Hh2qaOukP2fA49C78L03SagndMLwwGW3LJV9rD09cMeta || {},
    component: () => import("/app/app/pages/communications.vue")
  },
  {
    name: "legal-policy___en",
    path: "/legal/:policy()",
    meta: _91policy_93cOlG5PelEzOe5zZNG_H21QVFLd7aXStN9U138aikFjUMeta || {},
    component: () => import("/app/app/pages/legal/[policy].vue")
  },
  {
    name: "legal-policy___es",
    path: "/es/legal/:policy()",
    meta: _91policy_93cOlG5PelEzOe5zZNG_H21QVFLd7aXStN9U138aikFjUMeta || {},
    component: () => import("/app/app/pages/legal/[policy].vue")
  },
  {
    name: "legal-policy___pt",
    path: "/pt/legal/:policy()",
    meta: _91policy_93cOlG5PelEzOe5zZNG_H21QVFLd7aXStN9U138aikFjUMeta || {},
    component: () => import("/app/app/pages/legal/[policy].vue")
  },
  {
    name: "legal-policy___ja",
    path: "/ja/legal/:policy()",
    meta: _91policy_93cOlG5PelEzOe5zZNG_H21QVFLd7aXStN9U138aikFjUMeta || {},
    component: () => import("/app/app/pages/legal/[policy].vue")
  },
  {
    name: "legal-policy___ko",
    path: "/ko/legal/:policy()",
    meta: _91policy_93cOlG5PelEzOe5zZNG_H21QVFLd7aXStN9U138aikFjUMeta || {},
    component: () => import("/app/app/pages/legal/[policy].vue")
  },
  {
    name: "legal-policy___de",
    path: "/de/legal/:policy()",
    meta: _91policy_93cOlG5PelEzOe5zZNG_H21QVFLd7aXStN9U138aikFjUMeta || {},
    component: () => import("/app/app/pages/legal/[policy].vue")
  },
  {
    name: "legal-policy___it",
    path: "/it/legal/:policy()",
    meta: _91policy_93cOlG5PelEzOe5zZNG_H21QVFLd7aXStN9U138aikFjUMeta || {},
    component: () => import("/app/app/pages/legal/[policy].vue")
  },
  {
    name: "legal-policy___fr",
    path: "/fr/legal/:policy()",
    meta: _91policy_93cOlG5PelEzOe5zZNG_H21QVFLd7aXStN9U138aikFjUMeta || {},
    component: () => import("/app/app/pages/legal/[policy].vue")
  },
  {
    name: "legal-policy___zh",
    path: "/zh/legal/:policy()",
    meta: _91policy_93cOlG5PelEzOe5zZNG_H21QVFLd7aXStN9U138aikFjUMeta || {},
    component: () => import("/app/app/pages/legal/[policy].vue")
  },
  {
    name: "user-portal-kyc___en",
    path: "/user-portal/kyc",
    component: () => import("/app/app/pages/user-portal/kyc.vue")
  },
  {
    name: "user-portal-kyc___es",
    path: "/es/user-portal/kyc",
    component: () => import("/app/app/pages/user-portal/kyc.vue")
  },
  {
    name: "user-portal-kyc___pt",
    path: "/pt/user-portal/kyc",
    component: () => import("/app/app/pages/user-portal/kyc.vue")
  },
  {
    name: "user-portal-kyc___ja",
    path: "/ja/user-portal/kyc",
    component: () => import("/app/app/pages/user-portal/kyc.vue")
  },
  {
    name: "user-portal-kyc___ko",
    path: "/ko/user-portal/kyc",
    component: () => import("/app/app/pages/user-portal/kyc.vue")
  },
  {
    name: "user-portal-kyc___de",
    path: "/de/user-portal/kyc",
    component: () => import("/app/app/pages/user-portal/kyc.vue")
  },
  {
    name: "user-portal-kyc___it",
    path: "/it/user-portal/kyc",
    component: () => import("/app/app/pages/user-portal/kyc.vue")
  },
  {
    name: "user-portal-kyc___fr",
    path: "/fr/user-portal/kyc",
    component: () => import("/app/app/pages/user-portal/kyc.vue")
  },
  {
    name: "user-portal-kyc___zh",
    path: "/zh/user-portal/kyc",
    component: () => import("/app/app/pages/user-portal/kyc.vue")
  },
  {
    name: "user-portal-vip___en",
    path: "/user-portal/vip",
    component: () => import("/app/app/pages/user-portal/vip.vue")
  },
  {
    name: "user-portal-vip___es",
    path: "/es/user-portal/vip",
    component: () => import("/app/app/pages/user-portal/vip.vue")
  },
  {
    name: "user-portal-vip___pt",
    path: "/pt/user-portal/vip",
    component: () => import("/app/app/pages/user-portal/vip.vue")
  },
  {
    name: "user-portal-vip___ja",
    path: "/ja/user-portal/vip",
    component: () => import("/app/app/pages/user-portal/vip.vue")
  },
  {
    name: "user-portal-vip___ko",
    path: "/ko/user-portal/vip",
    component: () => import("/app/app/pages/user-portal/vip.vue")
  },
  {
    name: "user-portal-vip___de",
    path: "/de/user-portal/vip",
    component: () => import("/app/app/pages/user-portal/vip.vue")
  },
  {
    name: "user-portal-vip___it",
    path: "/it/user-portal/vip",
    component: () => import("/app/app/pages/user-portal/vip.vue")
  },
  {
    name: "user-portal-vip___fr",
    path: "/fr/user-portal/vip",
    component: () => import("/app/app/pages/user-portal/vip.vue")
  },
  {
    name: "user-portal-vip___zh",
    path: "/zh/user-portal/vip",
    component: () => import("/app/app/pages/user-portal/vip.vue")
  },
  {
    name: "under-maintenance___en",
    path: "/under-maintenance",
    meta: under_45maintenanceO2NKJ_bcwiHullFnM7Vvpyg2PaW8THtvL8JYd_6mF_kMeta || {},
    component: () => import("/app/app/pages/under-maintenance.vue")
  },
  {
    name: "under-maintenance___es",
    path: "/es/under-maintenance",
    meta: under_45maintenanceO2NKJ_bcwiHullFnM7Vvpyg2PaW8THtvL8JYd_6mF_kMeta || {},
    component: () => import("/app/app/pages/under-maintenance.vue")
  },
  {
    name: "under-maintenance___pt",
    path: "/pt/under-maintenance",
    meta: under_45maintenanceO2NKJ_bcwiHullFnM7Vvpyg2PaW8THtvL8JYd_6mF_kMeta || {},
    component: () => import("/app/app/pages/under-maintenance.vue")
  },
  {
    name: "under-maintenance___ja",
    path: "/ja/under-maintenance",
    meta: under_45maintenanceO2NKJ_bcwiHullFnM7Vvpyg2PaW8THtvL8JYd_6mF_kMeta || {},
    component: () => import("/app/app/pages/under-maintenance.vue")
  },
  {
    name: "under-maintenance___ko",
    path: "/ko/under-maintenance",
    meta: under_45maintenanceO2NKJ_bcwiHullFnM7Vvpyg2PaW8THtvL8JYd_6mF_kMeta || {},
    component: () => import("/app/app/pages/under-maintenance.vue")
  },
  {
    name: "under-maintenance___de",
    path: "/de/under-maintenance",
    meta: under_45maintenanceO2NKJ_bcwiHullFnM7Vvpyg2PaW8THtvL8JYd_6mF_kMeta || {},
    component: () => import("/app/app/pages/under-maintenance.vue")
  },
  {
    name: "under-maintenance___it",
    path: "/it/under-maintenance",
    meta: under_45maintenanceO2NKJ_bcwiHullFnM7Vvpyg2PaW8THtvL8JYd_6mF_kMeta || {},
    component: () => import("/app/app/pages/under-maintenance.vue")
  },
  {
    name: "under-maintenance___fr",
    path: "/fr/under-maintenance",
    meta: under_45maintenanceO2NKJ_bcwiHullFnM7Vvpyg2PaW8THtvL8JYd_6mF_kMeta || {},
    component: () => import("/app/app/pages/under-maintenance.vue")
  },
  {
    name: "under-maintenance___zh",
    path: "/zh/under-maintenance",
    meta: under_45maintenanceO2NKJ_bcwiHullFnM7Vvpyg2PaW8THtvL8JYd_6mF_kMeta || {},
    component: () => import("/app/app/pages/under-maintenance.vue")
  },
  {
    name: "user-id___en",
    path: "/user/:id()",
    component: () => import("/app/app/pages/(public)/user/[id].vue")
  },
  {
    name: "user-id___es",
    path: "/es/user/:id()",
    component: () => import("/app/app/pages/(public)/user/[id].vue")
  },
  {
    name: "user-id___pt",
    path: "/pt/user/:id()",
    component: () => import("/app/app/pages/(public)/user/[id].vue")
  },
  {
    name: "user-id___ja",
    path: "/ja/user/:id()",
    component: () => import("/app/app/pages/(public)/user/[id].vue")
  },
  {
    name: "user-id___ko",
    path: "/ko/user/:id()",
    component: () => import("/app/app/pages/(public)/user/[id].vue")
  },
  {
    name: "user-id___de",
    path: "/de/user/:id()",
    component: () => import("/app/app/pages/(public)/user/[id].vue")
  },
  {
    name: "user-id___it",
    path: "/it/user/:id()",
    component: () => import("/app/app/pages/(public)/user/[id].vue")
  },
  {
    name: "user-id___fr",
    path: "/fr/user/:id()",
    component: () => import("/app/app/pages/(public)/user/[id].vue")
  },
  {
    name: "user-id___zh",
    path: "/zh/user/:id()",
    component: () => import("/app/app/pages/(public)/user/[id].vue")
  },
  {
    name: "influencer-program___en",
    path: "/influencer-program",
    component: () => import("/app/app/pages/influencer-program.vue")
  },
  {
    name: "influencer-program___es",
    path: "/es/influencer-program",
    component: () => import("/app/app/pages/influencer-program.vue")
  },
  {
    name: "influencer-program___pt",
    path: "/pt/influencer-program",
    component: () => import("/app/app/pages/influencer-program.vue")
  },
  {
    name: "influencer-program___ja",
    path: "/ja/influencer-program",
    component: () => import("/app/app/pages/influencer-program.vue")
  },
  {
    name: "influencer-program___ko",
    path: "/ko/influencer-program",
    component: () => import("/app/app/pages/influencer-program.vue")
  },
  {
    name: "influencer-program___de",
    path: "/de/influencer-program",
    component: () => import("/app/app/pages/influencer-program.vue")
  },
  {
    name: "influencer-program___it",
    path: "/it/influencer-program",
    component: () => import("/app/app/pages/influencer-program.vue")
  },
  {
    name: "influencer-program___fr",
    path: "/fr/influencer-program",
    component: () => import("/app/app/pages/influencer-program.vue")
  },
  {
    name: "influencer-program___zh",
    path: "/zh/influencer-program",
    component: () => import("/app/app/pages/influencer-program.vue")
  },
  {
    name: "user-portal-offers___en",
    path: "/user-portal/offers",
    component: () => import("/app/app/pages/user-portal/offers.vue")
  },
  {
    name: "user-portal-offers___es",
    path: "/es/user-portal/offers",
    component: () => import("/app/app/pages/user-portal/offers.vue")
  },
  {
    name: "user-portal-offers___pt",
    path: "/pt/user-portal/offers",
    component: () => import("/app/app/pages/user-portal/offers.vue")
  },
  {
    name: "user-portal-offers___ja",
    path: "/ja/user-portal/offers",
    component: () => import("/app/app/pages/user-portal/offers.vue")
  },
  {
    name: "user-portal-offers___ko",
    path: "/ko/user-portal/offers",
    component: () => import("/app/app/pages/user-portal/offers.vue")
  },
  {
    name: "user-portal-offers___de",
    path: "/de/user-portal/offers",
    component: () => import("/app/app/pages/user-portal/offers.vue")
  },
  {
    name: "user-portal-offers___it",
    path: "/it/user-portal/offers",
    component: () => import("/app/app/pages/user-portal/offers.vue")
  },
  {
    name: "user-portal-offers___fr",
    path: "/fr/user-portal/offers",
    component: () => import("/app/app/pages/user-portal/offers.vue")
  },
  {
    name: "user-portal-offers___zh",
    path: "/zh/user-portal/offers",
    component: () => import("/app/app/pages/user-portal/offers.vue")
  },
  {
    name: "user-portal-activity___en",
    path: "/user-portal/activity",
    component: () => import("/app/app/pages/user-portal/activity.vue")
  },
  {
    name: "user-portal-activity___es",
    path: "/es/user-portal/activity",
    component: () => import("/app/app/pages/user-portal/activity.vue")
  },
  {
    name: "user-portal-activity___pt",
    path: "/pt/user-portal/activity",
    component: () => import("/app/app/pages/user-portal/activity.vue")
  },
  {
    name: "user-portal-activity___ja",
    path: "/ja/user-portal/activity",
    component: () => import("/app/app/pages/user-portal/activity.vue")
  },
  {
    name: "user-portal-activity___ko",
    path: "/ko/user-portal/activity",
    component: () => import("/app/app/pages/user-portal/activity.vue")
  },
  {
    name: "user-portal-activity___de",
    path: "/de/user-portal/activity",
    component: () => import("/app/app/pages/user-portal/activity.vue")
  },
  {
    name: "user-portal-activity___it",
    path: "/it/user-portal/activity",
    component: () => import("/app/app/pages/user-portal/activity.vue")
  },
  {
    name: "user-portal-activity___fr",
    path: "/fr/user-portal/activity",
    component: () => import("/app/app/pages/user-portal/activity.vue")
  },
  {
    name: "user-portal-activity___zh",
    path: "/zh/user-portal/activity",
    component: () => import("/app/app/pages/user-portal/activity.vue")
  },
  {
    name: "craft-merchant-id___en",
    path: "/craft/:merchant()/:id()",
    component: () => import("/app/app/pages/craft/[merchant]/[id].vue")
  },
  {
    name: "craft-merchant-id___es",
    path: "/es/craft/:merchant()/:id()",
    component: () => import("/app/app/pages/craft/[merchant]/[id].vue")
  },
  {
    name: "craft-merchant-id___pt",
    path: "/pt/craft/:merchant()/:id()",
    component: () => import("/app/app/pages/craft/[merchant]/[id].vue")
  },
  {
    name: "craft-merchant-id___ja",
    path: "/ja/craft/:merchant()/:id()",
    component: () => import("/app/app/pages/craft/[merchant]/[id].vue")
  },
  {
    name: "craft-merchant-id___ko",
    path: "/ko/craft/:merchant()/:id()",
    component: () => import("/app/app/pages/craft/[merchant]/[id].vue")
  },
  {
    name: "craft-merchant-id___de",
    path: "/de/craft/:merchant()/:id()",
    component: () => import("/app/app/pages/craft/[merchant]/[id].vue")
  },
  {
    name: "craft-merchant-id___it",
    path: "/it/craft/:merchant()/:id()",
    component: () => import("/app/app/pages/craft/[merchant]/[id].vue")
  },
  {
    name: "craft-merchant-id___fr",
    path: "/fr/craft/:merchant()/:id()",
    component: () => import("/app/app/pages/craft/[merchant]/[id].vue")
  },
  {
    name: "craft-merchant-id___zh",
    path: "/zh/craft/:merchant()/:id()",
    component: () => import("/app/app/pages/craft/[merchant]/[id].vue")
  },
  {
    name: "store-merchant-id___en",
    path: "/store/:merchant()/:id()",
    component: () => import("/app/app/pages/store/[merchant]/[id].vue")
  },
  {
    name: "store-merchant-id___es",
    path: "/es/store/:merchant()/:id()",
    component: () => import("/app/app/pages/store/[merchant]/[id].vue")
  },
  {
    name: "store-merchant-id___pt",
    path: "/pt/store/:merchant()/:id()",
    component: () => import("/app/app/pages/store/[merchant]/[id].vue")
  },
  {
    name: "store-merchant-id___ja",
    path: "/ja/store/:merchant()/:id()",
    component: () => import("/app/app/pages/store/[merchant]/[id].vue")
  },
  {
    name: "store-merchant-id___ko",
    path: "/ko/store/:merchant()/:id()",
    component: () => import("/app/app/pages/store/[merchant]/[id].vue")
  },
  {
    name: "store-merchant-id___de",
    path: "/de/store/:merchant()/:id()",
    component: () => import("/app/app/pages/store/[merchant]/[id].vue")
  },
  {
    name: "store-merchant-id___it",
    path: "/it/store/:merchant()/:id()",
    component: () => import("/app/app/pages/store/[merchant]/[id].vue")
  },
  {
    name: "store-merchant-id___fr",
    path: "/fr/store/:merchant()/:id()",
    component: () => import("/app/app/pages/store/[merchant]/[id].vue")
  },
  {
    name: "store-merchant-id___zh",
    path: "/zh/store/:merchant()/:id()",
    component: () => import("/app/app/pages/store/[merchant]/[id].vue")
  },
  {
    name: "user-portal-dashboard___en",
    path: "/user-portal/dashboard",
    component: () => import("/app/app/pages/user-portal/dashboard.vue")
  },
  {
    name: "user-portal-dashboard___es",
    path: "/es/user-portal/dashboard",
    component: () => import("/app/app/pages/user-portal/dashboard.vue")
  },
  {
    name: "user-portal-dashboard___pt",
    path: "/pt/user-portal/dashboard",
    component: () => import("/app/app/pages/user-portal/dashboard.vue")
  },
  {
    name: "user-portal-dashboard___ja",
    path: "/ja/user-portal/dashboard",
    component: () => import("/app/app/pages/user-portal/dashboard.vue")
  },
  {
    name: "user-portal-dashboard___ko",
    path: "/ko/user-portal/dashboard",
    component: () => import("/app/app/pages/user-portal/dashboard.vue")
  },
  {
    name: "user-portal-dashboard___de",
    path: "/de/user-portal/dashboard",
    component: () => import("/app/app/pages/user-portal/dashboard.vue")
  },
  {
    name: "user-portal-dashboard___it",
    path: "/it/user-portal/dashboard",
    component: () => import("/app/app/pages/user-portal/dashboard.vue")
  },
  {
    name: "user-portal-dashboard___fr",
    path: "/fr/user-portal/dashboard",
    component: () => import("/app/app/pages/user-portal/dashboard.vue")
  },
  {
    name: "user-portal-dashboard___zh",
    path: "/zh/user-portal/dashboard",
    component: () => import("/app/app/pages/user-portal/dashboard.vue")
  },
  {
    name: "user-portal-mint-id___en",
    path: "/user-portal/mint/:id()",
    component: () => import("/app/app/pages/user-portal/mint/[id].vue")
  },
  {
    name: "user-portal-mint-id___es",
    path: "/es/user-portal/mint/:id()",
    component: () => import("/app/app/pages/user-portal/mint/[id].vue")
  },
  {
    name: "user-portal-mint-id___pt",
    path: "/pt/user-portal/mint/:id()",
    component: () => import("/app/app/pages/user-portal/mint/[id].vue")
  },
  {
    name: "user-portal-mint-id___ja",
    path: "/ja/user-portal/mint/:id()",
    component: () => import("/app/app/pages/user-portal/mint/[id].vue")
  },
  {
    name: "user-portal-mint-id___ko",
    path: "/ko/user-portal/mint/:id()",
    component: () => import("/app/app/pages/user-portal/mint/[id].vue")
  },
  {
    name: "user-portal-mint-id___de",
    path: "/de/user-portal/mint/:id()",
    component: () => import("/app/app/pages/user-portal/mint/[id].vue")
  },
  {
    name: "user-portal-mint-id___it",
    path: "/it/user-portal/mint/:id()",
    component: () => import("/app/app/pages/user-portal/mint/[id].vue")
  },
  {
    name: "user-portal-mint-id___fr",
    path: "/fr/user-portal/mint/:id()",
    component: () => import("/app/app/pages/user-portal/mint/[id].vue")
  },
  {
    name: "user-portal-mint-id___zh",
    path: "/zh/user-portal/mint/:id()",
    component: () => import("/app/app/pages/user-portal/mint/[id].vue")
  },
  {
    name: "user-portal-referrals___en",
    path: "/user-portal/referrals",
    component: () => import("/app/app/pages/user-portal/referrals.vue")
  },
  {
    name: "user-portal-referrals___es",
    path: "/es/user-portal/referrals",
    component: () => import("/app/app/pages/user-portal/referrals.vue")
  },
  {
    name: "user-portal-referrals___pt",
    path: "/pt/user-portal/referrals",
    component: () => import("/app/app/pages/user-portal/referrals.vue")
  },
  {
    name: "user-portal-referrals___ja",
    path: "/ja/user-portal/referrals",
    component: () => import("/app/app/pages/user-portal/referrals.vue")
  },
  {
    name: "user-portal-referrals___ko",
    path: "/ko/user-portal/referrals",
    component: () => import("/app/app/pages/user-portal/referrals.vue")
  },
  {
    name: "user-portal-referrals___de",
    path: "/de/user-portal/referrals",
    component: () => import("/app/app/pages/user-portal/referrals.vue")
  },
  {
    name: "user-portal-referrals___it",
    path: "/it/user-portal/referrals",
    component: () => import("/app/app/pages/user-portal/referrals.vue")
  },
  {
    name: "user-portal-referrals___fr",
    path: "/fr/user-portal/referrals",
    component: () => import("/app/app/pages/user-portal/referrals.vue")
  },
  {
    name: "user-portal-referrals___zh",
    path: "/zh/user-portal/referrals",
    component: () => import("/app/app/pages/user-portal/referrals.vue")
  },
  {
    name: "craft-merchant___en",
    path: "/craft/:merchant()",
    component: () => import("/app/app/pages/craft/[merchant]/index.vue")
  },
  {
    name: "craft-merchant___es",
    path: "/es/craft/:merchant()",
    component: () => import("/app/app/pages/craft/[merchant]/index.vue")
  },
  {
    name: "craft-merchant___pt",
    path: "/pt/craft/:merchant()",
    component: () => import("/app/app/pages/craft/[merchant]/index.vue")
  },
  {
    name: "craft-merchant___ja",
    path: "/ja/craft/:merchant()",
    component: () => import("/app/app/pages/craft/[merchant]/index.vue")
  },
  {
    name: "craft-merchant___ko",
    path: "/ko/craft/:merchant()",
    component: () => import("/app/app/pages/craft/[merchant]/index.vue")
  },
  {
    name: "craft-merchant___de",
    path: "/de/craft/:merchant()",
    component: () => import("/app/app/pages/craft/[merchant]/index.vue")
  },
  {
    name: "craft-merchant___it",
    path: "/it/craft/:merchant()",
    component: () => import("/app/app/pages/craft/[merchant]/index.vue")
  },
  {
    name: "craft-merchant___fr",
    path: "/fr/craft/:merchant()",
    component: () => import("/app/app/pages/craft/[merchant]/index.vue")
  },
  {
    name: "craft-merchant___zh",
    path: "/zh/craft/:merchant()",
    component: () => import("/app/app/pages/craft/[merchant]/index.vue")
  },
  {
    name: "market-merchant-id___en",
    path: "/market/:merchant()/:id()",
    component: () => import("/app/app/pages/market/[merchant]/[id].vue")
  },
  {
    name: "market-merchant-id___es",
    path: "/es/market/:merchant()/:id()",
    component: () => import("/app/app/pages/market/[merchant]/[id].vue")
  },
  {
    name: "market-merchant-id___pt",
    path: "/pt/market/:merchant()/:id()",
    component: () => import("/app/app/pages/market/[merchant]/[id].vue")
  },
  {
    name: "market-merchant-id___ja",
    path: "/ja/market/:merchant()/:id()",
    component: () => import("/app/app/pages/market/[merchant]/[id].vue")
  },
  {
    name: "market-merchant-id___ko",
    path: "/ko/market/:merchant()/:id()",
    component: () => import("/app/app/pages/market/[merchant]/[id].vue")
  },
  {
    name: "market-merchant-id___de",
    path: "/de/market/:merchant()/:id()",
    component: () => import("/app/app/pages/market/[merchant]/[id].vue")
  },
  {
    name: "market-merchant-id___it",
    path: "/it/market/:merchant()/:id()",
    component: () => import("/app/app/pages/market/[merchant]/[id].vue")
  },
  {
    name: "market-merchant-id___fr",
    path: "/fr/market/:merchant()/:id()",
    component: () => import("/app/app/pages/market/[merchant]/[id].vue")
  },
  {
    name: "market-merchant-id___zh",
    path: "/zh/market/:merchant()/:id()",
    component: () => import("/app/app/pages/market/[merchant]/[id].vue")
  },
  {
    name: "store-merchant___en",
    path: "/store/:merchant()",
    component: () => import("/app/app/pages/store/[merchant]/index.vue")
  },
  {
    name: "store-merchant___es",
    path: "/es/store/:merchant()",
    component: () => import("/app/app/pages/store/[merchant]/index.vue")
  },
  {
    name: "store-merchant___pt",
    path: "/pt/store/:merchant()",
    component: () => import("/app/app/pages/store/[merchant]/index.vue")
  },
  {
    name: "store-merchant___ja",
    path: "/ja/store/:merchant()",
    component: () => import("/app/app/pages/store/[merchant]/index.vue")
  },
  {
    name: "store-merchant___ko",
    path: "/ko/store/:merchant()",
    component: () => import("/app/app/pages/store/[merchant]/index.vue")
  },
  {
    name: "store-merchant___de",
    path: "/de/store/:merchant()",
    component: () => import("/app/app/pages/store/[merchant]/index.vue")
  },
  {
    name: "store-merchant___it",
    path: "/it/store/:merchant()",
    component: () => import("/app/app/pages/store/[merchant]/index.vue")
  },
  {
    name: "store-merchant___fr",
    path: "/fr/store/:merchant()",
    component: () => import("/app/app/pages/store/[merchant]/index.vue")
  },
  {
    name: "store-merchant___zh",
    path: "/zh/store/:merchant()",
    component: () => import("/app/app/pages/store/[merchant]/index.vue")
  },
  {
    name: "market-merchant___en",
    path: "/market/:merchant()",
    component: () => import("/app/app/pages/market/[merchant]/index.vue")
  },
  {
    name: "market-merchant___es",
    path: "/es/market/:merchant()",
    component: () => import("/app/app/pages/market/[merchant]/index.vue")
  },
  {
    name: "market-merchant___pt",
    path: "/pt/market/:merchant()",
    component: () => import("/app/app/pages/market/[merchant]/index.vue")
  },
  {
    name: "market-merchant___ja",
    path: "/ja/market/:merchant()",
    component: () => import("/app/app/pages/market/[merchant]/index.vue")
  },
  {
    name: "market-merchant___ko",
    path: "/ko/market/:merchant()",
    component: () => import("/app/app/pages/market/[merchant]/index.vue")
  },
  {
    name: "market-merchant___de",
    path: "/de/market/:merchant()",
    component: () => import("/app/app/pages/market/[merchant]/index.vue")
  },
  {
    name: "market-merchant___it",
    path: "/it/market/:merchant()",
    component: () => import("/app/app/pages/market/[merchant]/index.vue")
  },
  {
    name: "market-merchant___fr",
    path: "/fr/market/:merchant()",
    component: () => import("/app/app/pages/market/[merchant]/index.vue")
  },
  {
    name: "market-merchant___zh",
    path: "/zh/market/:merchant()",
    component: () => import("/app/app/pages/market/[merchant]/index.vue")
  },
  {
    name: "collectible-id___en",
    path: "/collectible/:id()",
    component: () => import("/app/app/pages/(public)/collectible/[id].vue")
  },
  {
    name: "collectible-id___es",
    path: "/es/collectible/:id()",
    component: () => import("/app/app/pages/(public)/collectible/[id].vue")
  },
  {
    name: "collectible-id___pt",
    path: "/pt/collectible/:id()",
    component: () => import("/app/app/pages/(public)/collectible/[id].vue")
  },
  {
    name: "collectible-id___ja",
    path: "/ja/collectible/:id()",
    component: () => import("/app/app/pages/(public)/collectible/[id].vue")
  },
  {
    name: "collectible-id___ko",
    path: "/ko/collectible/:id()",
    component: () => import("/app/app/pages/(public)/collectible/[id].vue")
  },
  {
    name: "collectible-id___de",
    path: "/de/collectible/:id()",
    component: () => import("/app/app/pages/(public)/collectible/[id].vue")
  },
  {
    name: "collectible-id___it",
    path: "/it/collectible/:id()",
    component: () => import("/app/app/pages/(public)/collectible/[id].vue")
  },
  {
    name: "collectible-id___fr",
    path: "/fr/collectible/:id()",
    component: () => import("/app/app/pages/(public)/collectible/[id].vue")
  },
  {
    name: "collectible-id___zh",
    path: "/zh/collectible/:id()",
    component: () => import("/app/app/pages/(public)/collectible/[id].vue")
  },
  {
    name: "user-portal-account___en",
    path: "/user-portal/account",
    component: () => import("/app/app/pages/user-portal/account/index.vue")
  },
  {
    name: "user-portal-account___es",
    path: "/es/user-portal/account",
    component: () => import("/app/app/pages/user-portal/account/index.vue")
  },
  {
    name: "user-portal-account___pt",
    path: "/pt/user-portal/account",
    component: () => import("/app/app/pages/user-portal/account/index.vue")
  },
  {
    name: "user-portal-account___ja",
    path: "/ja/user-portal/account",
    component: () => import("/app/app/pages/user-portal/account/index.vue")
  },
  {
    name: "user-portal-account___ko",
    path: "/ko/user-portal/account",
    component: () => import("/app/app/pages/user-portal/account/index.vue")
  },
  {
    name: "user-portal-account___de",
    path: "/de/user-portal/account",
    component: () => import("/app/app/pages/user-portal/account/index.vue")
  },
  {
    name: "user-portal-account___it",
    path: "/it/user-portal/account",
    component: () => import("/app/app/pages/user-portal/account/index.vue")
  },
  {
    name: "user-portal-account___fr",
    path: "/fr/user-portal/account",
    component: () => import("/app/app/pages/user-portal/account/index.vue")
  },
  {
    name: "user-portal-account___zh",
    path: "/zh/user-portal/account",
    component: () => import("/app/app/pages/user-portal/account/index.vue")
  },
  {
    name: "collection-merchant___en",
    path: "/collection/:merchant()",
    component: () => import("/app/app/pages/collection/[merchant]/index.vue")
  },
  {
    name: "collection-merchant___es",
    path: "/es/collection/:merchant()",
    component: () => import("/app/app/pages/collection/[merchant]/index.vue")
  },
  {
    name: "collection-merchant___pt",
    path: "/pt/collection/:merchant()",
    component: () => import("/app/app/pages/collection/[merchant]/index.vue")
  },
  {
    name: "collection-merchant___ja",
    path: "/ja/collection/:merchant()",
    component: () => import("/app/app/pages/collection/[merchant]/index.vue")
  },
  {
    name: "collection-merchant___ko",
    path: "/ko/collection/:merchant()",
    component: () => import("/app/app/pages/collection/[merchant]/index.vue")
  },
  {
    name: "collection-merchant___de",
    path: "/de/collection/:merchant()",
    component: () => import("/app/app/pages/collection/[merchant]/index.vue")
  },
  {
    name: "collection-merchant___it",
    path: "/it/collection/:merchant()",
    component: () => import("/app/app/pages/collection/[merchant]/index.vue")
  },
  {
    name: "collection-merchant___fr",
    path: "/fr/collection/:merchant()",
    component: () => import("/app/app/pages/collection/[merchant]/index.vue")
  },
  {
    name: "collection-merchant___zh",
    path: "/zh/collection/:merchant()",
    component: () => import("/app/app/pages/collection/[merchant]/index.vue")
  },
  {
    name: "user-portal-account-devices___en",
    path: "/user-portal/account/devices",
    component: () => import("/app/app/pages/user-portal/account/devices.vue")
  },
  {
    name: "user-portal-account-devices___es",
    path: "/es/user-portal/account/devices",
    component: () => import("/app/app/pages/user-portal/account/devices.vue")
  },
  {
    name: "user-portal-account-devices___pt",
    path: "/pt/user-portal/account/devices",
    component: () => import("/app/app/pages/user-portal/account/devices.vue")
  },
  {
    name: "user-portal-account-devices___ja",
    path: "/ja/user-portal/account/devices",
    component: () => import("/app/app/pages/user-portal/account/devices.vue")
  },
  {
    name: "user-portal-account-devices___ko",
    path: "/ko/user-portal/account/devices",
    component: () => import("/app/app/pages/user-portal/account/devices.vue")
  },
  {
    name: "user-portal-account-devices___de",
    path: "/de/user-portal/account/devices",
    component: () => import("/app/app/pages/user-portal/account/devices.vue")
  },
  {
    name: "user-portal-account-devices___it",
    path: "/it/user-portal/account/devices",
    component: () => import("/app/app/pages/user-portal/account/devices.vue")
  },
  {
    name: "user-portal-account-devices___fr",
    path: "/fr/user-portal/account/devices",
    component: () => import("/app/app/pages/user-portal/account/devices.vue")
  },
  {
    name: "user-portal-account-devices___zh",
    path: "/zh/user-portal/account/devices",
    component: () => import("/app/app/pages/user-portal/account/devices.vue")
  },
  {
    name: "user-portal-collection-id___en",
    path: "/user-portal/collection/:id()",
    component: () => import("/app/app/pages/user-portal/collection/[id].vue")
  },
  {
    name: "user-portal-collection-id___es",
    path: "/es/user-portal/collection/:id()",
    component: () => import("/app/app/pages/user-portal/collection/[id].vue")
  },
  {
    name: "user-portal-collection-id___pt",
    path: "/pt/user-portal/collection/:id()",
    component: () => import("/app/app/pages/user-portal/collection/[id].vue")
  },
  {
    name: "user-portal-collection-id___ja",
    path: "/ja/user-portal/collection/:id()",
    component: () => import("/app/app/pages/user-portal/collection/[id].vue")
  },
  {
    name: "user-portal-collection-id___ko",
    path: "/ko/user-portal/collection/:id()",
    component: () => import("/app/app/pages/user-portal/collection/[id].vue")
  },
  {
    name: "user-portal-collection-id___de",
    path: "/de/user-portal/collection/:id()",
    component: () => import("/app/app/pages/user-portal/collection/[id].vue")
  },
  {
    name: "user-portal-collection-id___it",
    path: "/it/user-portal/collection/:id()",
    component: () => import("/app/app/pages/user-portal/collection/[id].vue")
  },
  {
    name: "user-portal-collection-id___fr",
    path: "/fr/user-portal/collection/:id()",
    component: () => import("/app/app/pages/user-portal/collection/[id].vue")
  },
  {
    name: "user-portal-collection-id___zh",
    path: "/zh/user-portal/collection/:id()",
    component: () => import("/app/app/pages/user-portal/collection/[id].vue")
  },
  {
    name: "user-portal-collection___en",
    path: "/user-portal/collection",
    component: () => import("/app/app/pages/user-portal/collection/index.vue")
  },
  {
    name: "user-portal-collection___es",
    path: "/es/user-portal/collection",
    component: () => import("/app/app/pages/user-portal/collection/index.vue")
  },
  {
    name: "user-portal-collection___pt",
    path: "/pt/user-portal/collection",
    component: () => import("/app/app/pages/user-portal/collection/index.vue")
  },
  {
    name: "user-portal-collection___ja",
    path: "/ja/user-portal/collection",
    component: () => import("/app/app/pages/user-portal/collection/index.vue")
  },
  {
    name: "user-portal-collection___ko",
    path: "/ko/user-portal/collection",
    component: () => import("/app/app/pages/user-portal/collection/index.vue")
  },
  {
    name: "user-portal-collection___de",
    path: "/de/user-portal/collection",
    component: () => import("/app/app/pages/user-portal/collection/index.vue")
  },
  {
    name: "user-portal-collection___it",
    path: "/it/user-portal/collection",
    component: () => import("/app/app/pages/user-portal/collection/index.vue")
  },
  {
    name: "user-portal-collection___fr",
    path: "/fr/user-portal/collection",
    component: () => import("/app/app/pages/user-portal/collection/index.vue")
  },
  {
    name: "user-portal-collection___zh",
    path: "/zh/user-portal/collection",
    component: () => import("/app/app/pages/user-portal/collection/index.vue")
  },
  {
    name: "user-portal-whats-new-builder___en",
    path: "/user-portal/whats-new-builder",
    component: () => import("/app/app/pages/user-portal/whats-new-builder.vue")
  },
  {
    name: "user-portal-whats-new-builder___es",
    path: "/es/user-portal/whats-new-builder",
    component: () => import("/app/app/pages/user-portal/whats-new-builder.vue")
  },
  {
    name: "user-portal-whats-new-builder___pt",
    path: "/pt/user-portal/whats-new-builder",
    component: () => import("/app/app/pages/user-portal/whats-new-builder.vue")
  },
  {
    name: "user-portal-whats-new-builder___ja",
    path: "/ja/user-portal/whats-new-builder",
    component: () => import("/app/app/pages/user-portal/whats-new-builder.vue")
  },
  {
    name: "user-portal-whats-new-builder___ko",
    path: "/ko/user-portal/whats-new-builder",
    component: () => import("/app/app/pages/user-portal/whats-new-builder.vue")
  },
  {
    name: "user-portal-whats-new-builder___de",
    path: "/de/user-portal/whats-new-builder",
    component: () => import("/app/app/pages/user-portal/whats-new-builder.vue")
  },
  {
    name: "user-portal-whats-new-builder___it",
    path: "/it/user-portal/whats-new-builder",
    component: () => import("/app/app/pages/user-portal/whats-new-builder.vue")
  },
  {
    name: "user-portal-whats-new-builder___fr",
    path: "/fr/user-portal/whats-new-builder",
    component: () => import("/app/app/pages/user-portal/whats-new-builder.vue")
  },
  {
    name: "user-portal-whats-new-builder___zh",
    path: "/zh/user-portal/whats-new-builder",
    component: () => import("/app/app/pages/user-portal/whats-new-builder.vue")
  },
  {
    name: "market-merchant-stack-setId___en",
    path: "/market/:merchant()/stack/:setId()",
    component: () => import("/app/app/pages/market/[merchant]/stack/[setId].vue")
  },
  {
    name: "market-merchant-stack-setId___es",
    path: "/es/market/:merchant()/stack/:setId()",
    component: () => import("/app/app/pages/market/[merchant]/stack/[setId].vue")
  },
  {
    name: "market-merchant-stack-setId___pt",
    path: "/pt/market/:merchant()/stack/:setId()",
    component: () => import("/app/app/pages/market/[merchant]/stack/[setId].vue")
  },
  {
    name: "market-merchant-stack-setId___ja",
    path: "/ja/market/:merchant()/stack/:setId()",
    component: () => import("/app/app/pages/market/[merchant]/stack/[setId].vue")
  },
  {
    name: "market-merchant-stack-setId___ko",
    path: "/ko/market/:merchant()/stack/:setId()",
    component: () => import("/app/app/pages/market/[merchant]/stack/[setId].vue")
  },
  {
    name: "market-merchant-stack-setId___de",
    path: "/de/market/:merchant()/stack/:setId()",
    component: () => import("/app/app/pages/market/[merchant]/stack/[setId].vue")
  },
  {
    name: "market-merchant-stack-setId___it",
    path: "/it/market/:merchant()/stack/:setId()",
    component: () => import("/app/app/pages/market/[merchant]/stack/[setId].vue")
  },
  {
    name: "market-merchant-stack-setId___fr",
    path: "/fr/market/:merchant()/stack/:setId()",
    component: () => import("/app/app/pages/market/[merchant]/stack/[setId].vue")
  },
  {
    name: "market-merchant-stack-setId___zh",
    path: "/zh/market/:merchant()/stack/:setId()",
    component: () => import("/app/app/pages/market/[merchant]/stack/[setId].vue")
  },
  {
    name: "craft-merchant-category-categoryId___en",
    path: "/craft/:merchant()/category/:categoryId()",
    component: () => import("/app/app/pages/craft/[merchant]/category/[categoryId].vue")
  },
  {
    name: "craft-merchant-category-categoryId___es",
    path: "/es/craft/:merchant()/category/:categoryId()",
    component: () => import("/app/app/pages/craft/[merchant]/category/[categoryId].vue")
  },
  {
    name: "craft-merchant-category-categoryId___pt",
    path: "/pt/craft/:merchant()/category/:categoryId()",
    component: () => import("/app/app/pages/craft/[merchant]/category/[categoryId].vue")
  },
  {
    name: "craft-merchant-category-categoryId___ja",
    path: "/ja/craft/:merchant()/category/:categoryId()",
    component: () => import("/app/app/pages/craft/[merchant]/category/[categoryId].vue")
  },
  {
    name: "craft-merchant-category-categoryId___ko",
    path: "/ko/craft/:merchant()/category/:categoryId()",
    component: () => import("/app/app/pages/craft/[merchant]/category/[categoryId].vue")
  },
  {
    name: "craft-merchant-category-categoryId___de",
    path: "/de/craft/:merchant()/category/:categoryId()",
    component: () => import("/app/app/pages/craft/[merchant]/category/[categoryId].vue")
  },
  {
    name: "craft-merchant-category-categoryId___it",
    path: "/it/craft/:merchant()/category/:categoryId()",
    component: () => import("/app/app/pages/craft/[merchant]/category/[categoryId].vue")
  },
  {
    name: "craft-merchant-category-categoryId___fr",
    path: "/fr/craft/:merchant()/category/:categoryId()",
    component: () => import("/app/app/pages/craft/[merchant]/category/[categoryId].vue")
  },
  {
    name: "craft-merchant-category-categoryId___zh",
    path: "/zh/craft/:merchant()/category/:categoryId()",
    component: () => import("/app/app/pages/craft/[merchant]/category/[categoryId].vue")
  },
  {
    name: "store-merchant-category-categoryId___en",
    path: "/store/:merchant()/category/:categoryId()",
    component: () => import("/app/app/pages/store/[merchant]/category/[categoryId].vue")
  },
  {
    name: "store-merchant-category-categoryId___es",
    path: "/es/store/:merchant()/category/:categoryId()",
    component: () => import("/app/app/pages/store/[merchant]/category/[categoryId].vue")
  },
  {
    name: "store-merchant-category-categoryId___pt",
    path: "/pt/store/:merchant()/category/:categoryId()",
    component: () => import("/app/app/pages/store/[merchant]/category/[categoryId].vue")
  },
  {
    name: "store-merchant-category-categoryId___ja",
    path: "/ja/store/:merchant()/category/:categoryId()",
    component: () => import("/app/app/pages/store/[merchant]/category/[categoryId].vue")
  },
  {
    name: "store-merchant-category-categoryId___ko",
    path: "/ko/store/:merchant()/category/:categoryId()",
    component: () => import("/app/app/pages/store/[merchant]/category/[categoryId].vue")
  },
  {
    name: "store-merchant-category-categoryId___de",
    path: "/de/store/:merchant()/category/:categoryId()",
    component: () => import("/app/app/pages/store/[merchant]/category/[categoryId].vue")
  },
  {
    name: "store-merchant-category-categoryId___it",
    path: "/it/store/:merchant()/category/:categoryId()",
    component: () => import("/app/app/pages/store/[merchant]/category/[categoryId].vue")
  },
  {
    name: "store-merchant-category-categoryId___fr",
    path: "/fr/store/:merchant()/category/:categoryId()",
    component: () => import("/app/app/pages/store/[merchant]/category/[categoryId].vue")
  },
  {
    name: "store-merchant-category-categoryId___zh",
    path: "/zh/store/:merchant()/category/:categoryId()",
    component: () => import("/app/app/pages/store/[merchant]/category/[categoryId].vue")
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/auth",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/es/auth",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/pt/auth",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/ja/auth",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/ko/auth",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/de/auth",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/it/auth",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/fr/auth",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/zh/auth",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/auth/login",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/es/auth/login",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/pt/auth/login",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/ja/auth/login",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/ko/auth/login",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/de/auth/login",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/it/auth/login",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/fr/auth/login",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/zh/auth/login",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/auth/signup",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/es/auth/signup",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/pt/auth/signup",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/ja/auth/signup",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/ko/auth/signup",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/de/auth/signup",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/it/auth/signup",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/fr/auth/signup",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/zh/auth/signup",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  }
]